import Api from './ApiNode'

export default {
  objekt (postData) {
    return Api().post('/search/objekt', postData)
  },
  kunde (postData) {
    return Api().post('/search/kunde', postData)
  }
}



// WEBPACK FOOTER //
// ./src/services/NodeService.js